import React from "react";
import { useParams } from "react-router-dom";
import { Lessons } from "../projects/Lessons";

export const LessonsArchive = () => {
  const { scope = "" } = useParams();

  return <Lessons lessonsFrom={scope} readOnly />;
};
